import axios from 'axios'

export default {
  search (query) {
    return axios.get(`https://api.giphy.com/v1/gifs/search?q=${query}&api_key=${process.env.GIPHY_API_KEY}&rating=pg`)
      .catch((err) => { window.alert(err) })
  }
}
